import { Component, Input } from '@angular/core';
import { CarreraModel } from 'app/modules/models/carreras.model';
import { ExperienciaInterface } from './requerimientos.model';

@Component({
    selector: 'app-requerimiento-card',
    templateUrl: 'requerimiento-card.component.html',
    standalone: true,
})
export class RequerimientoCardComponent {
    @Input() palabras: string[] = [];
    @Input() requerimientos : ExperienciaInterface
}
